export type MarketingPageKey = 'about' | 'pricing' | 'faq' | 'privacy' | 'terms' | 'help' | 'releases' | 'contact';

export const ROUTES = {
  ABOUT: '/about',
  PRICING: '/pricing',
  FAQ: '/faq',
  HELP: '/help',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  RELEASES: '/releases',
  CONTACT: '/contact',
  SETTINGS: '/settings'
} as const;

/** The previous Image Slicer (v2), kept up for people who want the old one. Linked nofollow. */
export const V2_SITE_URL = 'https://v2.imageslicer.com';
